module.exports = __webpack_public_path__ + "img/gitlab.54b1ba40.png";